var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaskell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#463B63",
    d: "M0 110.2L30.1 65 0 19.9h22.6L52.7 65l-30.1 45.1H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5187",
    d: "M30.1 110.2L60.2 65 30.1 19.9h22.6l60.2 90.3H90.4L71.5 81.9l-18.8 28.2H30.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#904F8C",
    d: "M102.9 83.8l-10-15.1H128v15.1h-25.1zM87.8 61.3l-10-15.1H128v15.1H87.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaskell);
export default __webpack_public_path__ + "static/media/Haskell.084122e02bec646ad186861642137932.svg";
export { ForwardRef as ReactComponent };